import { render, staticRenderFns } from "./CopPreguntas.vue?vue&type=template&id=4667c853&scoped=true"
import script from "./CopPreguntas.vue?vue&type=script&lang=js"
export * from "./CopPreguntas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4667c853",
  null
  
)

export default component.exports